import { api } from "@/lib/api";

export const reportsApi = {
  catalog: () => api.get("/reports/catalog").then((r) => r.data),
  run: (key, params) => api.get(`/reports/run/${key}`, { params }).then((r) => r.data),
  exportCsv: async (key, params) => {
    const res = await api.get(`/reports/export/${key}`, { params, responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = `${key}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};

export const fmt = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "number") return v.toLocaleString("en-IN", { maximumFractionDigits: 2 });
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}T/.test(v)) return new Date(v).toLocaleDateString("en-IN");
  if (typeof v === "object") return v.name || v.company_name || "—";
  return String(v);
};
